import React from "react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-zinc-900 text-white">
      <h1 className="text-5xl font-bold mb-4">404</h1>
      <p className="text-zinc-400 text-lg mb-6">Page not found.</p>
      <a href="/" className="text-[#00b894] underline">← Back to Home</a>
    </div>
  );
}

